module.exports = __webpack_public_path__ + "static/media/iconSms.923372cb.svg";